var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVectorAlliesBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 767,
    height: 393,
    viewBox: "0 0 767 393",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.3961 0.158074C197.259 0.596491 192.692 98.1071 205.914 162.719C219.135 227.324 246.549 264.181 310.365 231.622C374.181 199.063 425.579 180.495 478.659 235.554C531.738 290.613 561.821 319.562 653.988 278.644C746.161 237.733 825.256 412.562 706.744 434.102C588.231 455.642 529.805 424.018 323.363 468.526C116.922 513.033 -41.912 474.56 -57.4753 299.96C-73.0385 125.36 -35.4967 -0.147162 61.3961 0.158074Z",
    fill: "url(#paint0_linear_387_1262)",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_387_1262",
    x1: 50.0137,
    y1: 215.013,
    x2: 768.107,
    y2: 319.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#323A73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81C23D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorAlliesBg);
export default __webpack_public_path__ + "static/media/VectorAlliesBg.27e80925d8fa48778585220ec6b67351.svg";
export { ForwardRef as ReactComponent };